// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Landing from "../../templates/Landing.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

var heroImg = {
  src: "https://images.instapainting.com/5acb436087456fa4698b457b.jpg",
  alt: "A colorful parrot on a twig painted in oil"
};

var pageTitle = "Custom Bird Portrait Painting";

var metaDescription = "Turn your bird photo into a personalized, handmade portrait. View thousands of examples from real customers. Ready to be shipped in about 7-10 days.";

var title = "Order a personalized";

var title2 = " oil painting of your bird";

var description = "Turn your favorite photo into a 100% handmade physical painting from a master artist in oil, watercolor, charcoal, or other mediums. Select a product, upload a photo, and we'll find the best bird paintings artist to make it and ship it to your door. All you have to do to get started is upload your horse’s photo!";

var secondaryContent = {
  title1: "Custom Horse",
  title2: "Portrait Painting",
  body: "You can browse bird painting samples from real customers and artists. Take a look and you’ll find that our artists can create a variety of types of custom bird paintings, tailored to your specific preferences and needs. Whether you’re shopping for a housewarming gift, a birthday present, retirement gift, or you want a special way to memorialize the life of your favorite feathered friend, look no further than Instapainting. Our custom bird portraits are 100% handmade by talented artists with years of professional experience. You can work directly with the artist of your choice to commission a one-of-a-kind bird painting that you’ll enjoy for a lifetime."
};

var mainCta = {
  text: "Upload a Photo",
  link: "/assets"
};

var altCta = {
  text: "Browse Horses Gallery",
  link: "/gallery/bird"
};

var products = [
  {
    title: "Oil Painting",
    src: "https://images.instapainting.com/60ec1823a991725f478b4569.jpg?fp-z=1.25&fp-x=0.4&fp-y=0.5",
    imageAlt: "Oil painting of the rear of a large flightless bird with chicks following",
    sku: "custphotoreal",
    price: 89
  },
  {
    title: "Watercolor",
    src: "https://images.instapainting.com/5dbe9ab787456ffc778b457f_w0.jpg?fp-z=1.2&fp-y=0.55",
    imageAlt: "A bunch of swans in a river in a city painted in watercolor",
    sku: "custwatercolor",
    price: 89
  },
  {
    title: "Colored-Pencil",
    src: "https://images.instapainting.com/5a3a4d0987456f01228b4569.jpg?fp-z=1.0",
    imageAlt: "A colorful parrot standing on a branch with one foot up drawn with colored pencils",
    sku: "custpencil",
    price: 89
  }
];

var reviews = [
  {
    name: "Thomas Rylander",
    location: "Madison, US",
    review: "The painting is a delightful addition to our home. We will cherish it forever. It was the best gift I have ever given my spouse. My only regret is that I didn't get the talented artist to sign it.",
    link: "/products/gallery/custphotoreal/5f56fac987456f81328b4568/?order=1",
    image: "https://images.instapainting.com/5f6088fb87456f17528b4573.jpg?fit=crop&crop=focalpoint&fp-y=.55&fp-z=2",
    imageAlt: "A chicken painted in oil in the style of Fur",
    date: new Date("10/06/2020")
  },
  {
    name: "Winter L Smith",
    location: "Winchester, US",
    review: "Kimberly Miller of Fine Art did a very good job painting the picture of birds and their nest I sent her. She sent messages about how the painting was coming along and gave me a chance to make any changes.",
    link: "/products/gallery/custphotoreal/5ea0f14287456f72028b4592/?order=1",
    image: "https://images.instapainting.com/5eb95ab387456f09268b4583_w0.jpg",
    imageAlt: "A mother bird with chicks and an egg next to her painted in oil on canvas",
    date: new Date("05/12/2020")
  },
  {
    name: "Andrew Burford",
    location: "Lilyfield, US",
    review: "Fantastic job adapting the image to a painting — I had 3 minor adjustments and they executed it perfectly.",
    link: "/products/gallery/custphotoreal/5f52b93587456f0d4a8b456f/?order=1",
    image: "https://images.instapainting.com/5f68246f87456fe4768b456e_w0.jpg",
    imageAlt: "A photoshopped picture of a guy in a scene with dinosaurs and pterodactyls in the background painted in oil",
    date: new Date("10/12/2020")
  }
];

var contentBlocks = [
  {
    title1: "Hand-Painted Portrait of",
    title2: "Your Favorite Feathered Friend",
    body: "Just like dogs and cats, birds often have a special place in your heart and family. Capture your bird’s unique personality with a gorgeous custom bird portrait that’s painted from a photo. We understand that your bird is special to you and that’s why we put so much care into making sure you get a beautiful, high-quality bird portrait that accurately represents the love you have for your adorable pet.\n\nWhen you order a portrait through Instapainting, you can expect nothing less than the highest quality finished product. We will connect you with a professional artist that has the skills and experience to create a beautiful masterpiece you’ll cherish for life. Once you select your artist, you’ll get to work directly with him or her to provide instructions on what you want and provide feedback during the production process. That way, you get exactly what you want (no unfortunate surprises!) and you don’t have to completely blow your budget to get it."
  },
  {
    title1: "Capture Your Adorable Avian",
    title2: "on Canvas",
    body: "Some moments are just too difficult or special to encapsulate with words. So, why not capture them with a gorgeous custom bird painting you can display in your home? Or, if you need a creative birthday gift, pet memorial gift, or a donation for an organization you love, let us help you create something truly special!\n\nEvery sweet avian friend has its own unique personality and our professional artists can create a custom portrait that speaks for itself. All of our artists use the highest quality materials to create products that look and feel beautiful and will withstand the test of time. They will work one-on-one with you to make sure your custom bird painting accurately portrays your special feathered friend and is everything you hoped and dreamed it would be."
  },
  {
    title1: "Turn a Funny Photo",
    title2: "Into a Cherished Memory",
    body: "You know that hilarious photo of your pet bird that you look at every so often to cheer you up and make you smile? That’s the perfect type of photo to use for a custom bird portrait. Our artists can create a beautiful and striking painting based on your funny photo that will make you laugh, bring you joy, and that you will appreciate long after you have to say goodbye to your bird in this life.\n\nOnce you upload your bird’s funny photo, you can select an artist based on your stylistic preferences and budget. That artist will work with you to create a handcrafted funny bird portrait that you can keep for yourself, give to a family member, or donate to a worthy cause. However you choose to use your painting, you can be sure that it will be enjoyed and admired for years to come."
  },
  {
    title1: "",
    title2: "Start by Uploading Your Photo Today",
    body: "If you’re ready to commission your custom bird portrait, our professional artists are available to help you now! Instead of locating an artist on your own, vetting them, and working with them all on your own, Instapainting makes the process smooth, easy, and quick. You can start by selecting the type of artwork you want. Then, you’ll need to upload your bird’s photo, write detailed instructions for the artist, and finally, you can submit your order!\n\nOnce we receive your order, we’ll continue working with you to select an artist based on your stylistic preferences, their availability, and your budget and timeline. From there, the project is off to a start, and you can expect to review the custom bird portrait unlimited times before it’s finalized and safely shipped to your home. Generally, our custom bird portraits take three weeks or less to receive, from start to finish.\n\nReady to get started? Upload a precious photo of your bird today!"
  }
];

function BirdPaintingsPage(props) {
  return JsxRuntime.jsx(Landing.LandingPage.make, {
              pageTitle: pageTitle,
              heroImg: heroImg,
              title: title,
              title2: title2,
              description: description,
              metaDescription: metaDescription,
              secondaryContent: secondaryContent,
              mainCta: mainCta,
              altCta: altCta,
              products: products,
              reviews: reviews,
              contentBlocks: contentBlocks
            });
}

var make = BirdPaintingsPage;

var $$default = BirdPaintingsPage;

export {
  heroImg ,
  pageTitle ,
  metaDescription ,
  title ,
  title2 ,
  description ,
  secondaryContent ,
  mainCta ,
  altCta ,
  products ,
  reviews ,
  contentBlocks ,
  make ,
  $$default as default,
}
/*  Not a pure module */
